export default `id
name
paymentIssuerId`
